import React from "react";
import axios from "axios";

import { isMobile } from "react-device-detect";
import { Footer, Header, Notification, Button, Modal, Table, Select, Card, Progress } from "@scuf/common";
import 'react-toastify/dist/ReactToastify.css';
import '../toast-notification-wrap.css'


const ReactToastify = require('react-toastify');

const config = require("../config.json");
const APIResultado = config.api_resultado
const apiKey = config.authorization;
const headers = { 'authorization': apiKey }


const ToastNotification = ({ closeToast, Texto }) => (
    <Notification
        className="toast-notification"
        severity="critical"
        onCloseClick={closeToast}
        hasIcon={true}
        title={Texto}
        detailsText="Intentelo nuevamente"
        onDetailsClick={() => { }} //{() => alert('Debie ingresar todos los datos para continuar')}
    />

)


export default class Votar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            candidatos: [],
            selector: [],
            votos: [],
            nvotos: 0,
            habilitarBoton: false,
            comenzar: 0,
            hidden: "hidden",
            modal: false,
            modalFin: false,
            query: ""
        };


        this.onButtonClick = this.onButtonClick.bind(this);
        this.onReporteClick = this.onReporteClick.bind(this);

        this.click_ModalSi = this.click_ModalSi.bind(this);
        this.click_ModalNo = this.click_ModalNo.bind(this);
    }




    componentWillMount() {

        const candidatos = this.props.candidatos
        var listacandidatos = []
        candidatos.map((item) =>
            listacandidatos.push({ 'value': item.dato1, 'text': item.dato2 })
        )

        this.setState({
            candidatos: candidatos,
            selector: listacandidatos
        })

    }


    handleOnChange = (value) => {

        let votos = value
        let nvotos = votos.length
        this.setState({ votos: votos, nvotos: nvotos })

    }

    onButtonClick() {
        this.setState({ modal: true })
    }

    click_ModalSi() {
        try {
            this.setState({ isLoading: true, modal: false });

            var addResultados = ""
            this.state.votos.map((item) =>
                /*addResultados += `EXECUTE dbo.add_Resultado '${this.props.idEleccion}', '${this.props.RUT}', '${item}';`*/
                addResultados += `('${this.props.idEleccion}', '${this.props.RUT}', '${item}'),`
            )

            /*addResultados += `exec[dbo].[sp_SendMail] '${this.props.Email}','Tu voto ha sido registrado. Muchas gracias por participar.';`*/


            axios.post(`${APIResultado}`,
                {
                    "Query": addResultados
                },
                { headers: headers })
                .then((res) => {
                    const items = res.data;
                    this.setState({
                        modalFin: true,
                        query: items[0].Mensaje,
                    });
                });


        } catch (e) {
            console.log(e);
            this.setState({
                query: e,
                isLoading: false
            });
        }
    }

    click_ModalNo() {
        this.setState({ modal: false });
    }

    click_ModalFin() {
        window.location.reload(false);
    }


    onReporteClick() {
        this.setState({ comenzar: 2 })
    }

    render() {

        return (
            <React.Fragment>
                {/*{JSON.stringify(this.state.votos)}<br />*/}
                {/*{JSON.stringify(this.state.nvotos)}<br />*/}
                {/*{JSON.stringify(this.props.Email)}<br />*/}
                {/*{JSON.stringify(this.state.query)}*/}

                <Header title="Elecciones" menu={false}>
                </Header>
                <div className={isMobile ? "" : "PC"}>
                    <Card closeIcon={true}>
                        <Card.Header title="Bienvenido" />
                        <Card.Content>
                            En el siguiente cuadro encontrará el listado de todos los trabajadores. Deberá elegir a {this.props.NVotos} personas dentro del listado. Podrá buscarlos escribiendo el nombre de la persona por quien desea votar.
                            </Card.Content>
                    </Card>

                    {this.renderModal()}
                    {this.renderModalFin()}

                    <Table>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell textAlign="center">
                                    <div className={this.state.nvotos > this.props.NVotos ? "" : "hidden"} style={{ paddingTop: 10 }}>
                                        <Progress stackedValues={[0, 0, 100]} unit="%" size="xlarge" />
                                    </div>
                                    <div className={this.state.nvotos < this.props.NVotos ? "" : "hidden"} style={{ paddingTop: 10 }}>
                                        <Progress percent={Math.floor(100 * (this.state.nvotos / this.props.NVotos))} size="xlarge" />

                                    </div>
                                    <div className={this.state.nvotos === this.props.NVotos ? "" : "hidden"} style={{ paddingTop: 10 }}>
                                        <Button className="fullanchos" disabled={this.state.nvotos === this.props.NVotos || !this.state.isLoading ? false : true} loading={this.state.isLoading} fluid={true} content="Votar" onClick={this.onButtonClick} />
                                    </div>
                                    <br />
                                    <Select search={true} multiple={true} fluid={true} placeholder="Votar Por..." options={this.state.selector} onChange={(value) => this.handleOnChange(value)} />


                                    {/*<BrowserView>*/}
                                    {/*    <div style={{ paddingTop: 10 }}>*/}
                                    {/*        <td onClick={this.onReporteClick}><Icon name={"document-report"} root="common" /></td>*/}
                                    {/*    </div>*/}
                                    {/*</BrowserView>*/}

                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </div>

                {/*{*/}
                {/*    (() => {*/}
                {/*        switch (this.state.idUsuario) {*/}
                {/*            case -1:*/}
                {/*                ReactToastify.toast(<ToastNotification Texto={"Usuario Invalido"} closeToast={true} />);*/}
                {/*                this.setState({ idUsuario: 0 })*/}
                {/*                break;*/}
                {/*            case -2:*/}
                {/*                ReactToastify.toast(<ToastNotification Texto={"Error API"} closeToast={true} />);*/}
                {/*                this.setState({ idUsuario: 0 })*/}
                {/*                break;*/}
                {/*            default:*/}
                {/*                return null;*/}
                {/*        }*/}
                {/*    })()*/}
                {/*}*/}


                <div>
                    <ReactToastify.ToastContainer
                        hideProgressBar={false}
                        closeOnClick={false}
                        closeButton={false}
                        newestOnTop={true}
                        position="bottom-right"
                        autoClose={2500}
                        toastClassName="toast-notification-wrap"
                    />
                </div>

                <div>
                    <Footer copyrightText={"© " + new Date().getFullYear() + " Honeywell Chile"}>
                        <Footer.Item href="#">Terms & Conditions</Footer.Item>
                        <Footer.Item href="#">Privacy Policy</Footer.Item>
                    </Footer>
                </div>
            </React.Fragment >

        );
    }

    renderModal() {
        return (
            <Modal closeIcon={true} size="mini" onClose={() => this.setState({ modal: false })} open={this.state.modal} closeOnDimmerClick={false}>
                <Modal.Header>
                    ¿Está Seguro?
                </Modal.Header>
                <Modal.Content>
                </Modal.Content>
                <Modal.Footer>
                    <Button type="secondary" size="small" content="No" onClick={this.click_ModalNo} disabled={this.state.isLoading} />
                    <Button type="primary" size="small" content="Si" onClick={this.click_ModalSi} disabled={this.state.isLoading} />
                </Modal.Footer>
            </Modal>
        );
    }

    renderModalFin() {
        return (
            <Modal size="mini" onClose={() => this.setState({ modalFin: false })} open={this.state.modalFin} closeOnDimmerClick={false}>
                <Modal.Header>
                    Voto Enviado
                </Modal.Header>
                <Modal.Content>
                    Muchas Gracias
                </Modal.Content>
                <Modal.Footer>
                    <Button type="secondary" size="small" content="Cerrar" onClick={this.click_ModalFin} />
                </Modal.Footer>
            </Modal>
        );
    }


    notify() {
        ReactToastify.toast(<ToastNotification closeToast={true} />)
    }

}
